import { useState, useEffect } from 'react';

export function useScrollHide(threshold: number = 50) {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsHidden(scrollY > threshold);
    };

    // Only add scroll listener on mobile devices
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return isHidden;
}
